module.exports = __webpack_public_path__ + "static/media/GA_wordmark_black-1-1.c393f066.svg";